module.exports = __webpack_public_path__ + "assets/clipboard.d5d113f3.svg";